var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Layout", [
    _c("div", { staticClass: "ep__main_content pt-80" }, [
      _c("section", { staticClass: "content pt-40" }, [
        _c(
          "div",
          { staticClass: "container spage p-0" },
          [
            _c(
              "EpPageTitle",
              { staticClass: "spage__br-bt mb-0 p-40" },
              [
                _c("EpLabel", { staticClass: "mb-0 spage__headtile" }, [
                  _vm._v("USER GUIDE")
                ])
              ],
              1
            ),
            _vm.country
              ? _c("div", { staticClass: "user-guide-content mb-40" }, [
                  _c("p", { staticClass: "user-guide-download-label" }, [
                    _vm._v("Download the User Guide as PDF")
                  ]),
                  _c(
                    "p",
                    { staticClass: "m-0" },
                    [
                      _vm._v(
                        "You can click the PDF file below to download User Guide. If you can't find what you're looking for, please "
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass: "user-guide-contact-us",
                          attrs: { to: "/" + _vm.countryCode + "/contact-us" }
                        },
                        [_vm._v("contact us")]
                      ),
                      _vm._v(" to get help.")
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-inline-flex align-items-center mt-32 mb-32 user-guide-download-box"
                    },
                    [
                      _c("img", {
                        staticClass: "mr-8",
                        attrs: {
                          src: require("@static/img/pdf.svg"),
                          alt: "proceed-to-pay-icon",
                          height: "32px",
                          width: "32px"
                        }
                      }),
                      _c(
                        "a",
                        {
                          staticClass: "mr-8 download-pdf",
                          attrs: {
                            href:
                              _vm.country.userGuide.filePath +
                              "?v=" +
                              Date.now(),
                            download: ""
                          }
                        },
                        [_vm._v("E-Payment User Guide.pdf")]
                      ),
                      _c("span", { staticClass: "mr-8" }, [_vm._v("-")]),
                      _c("span", {}, [
                        _vm._v(_vm._s(_vm.country.userGuide.fileSize))
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column",
                      attrs: { "data-testid": "publication-date" }
                    },
                    [
                      _c("span", { staticClass: "date-title" }, [
                        _vm._v("Publication date:")
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.country.userGuide.publicationDate))
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column mt-16",
                      attrs: { "data-testid": "last-updated" }
                    },
                    [
                      _c("span", { staticClass: "date-title" }, [
                        _vm._v("Last updated:")
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.country.userGuide.lastUpdated))
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }